import { useMutation, useQuery } from '@tanstack/react-query';

import {
  createKeywordGroup,
  createKeywords,
  deleteKeywordGroups,
  deleteKeywords,
  getKeywordGroupById,
  getKeywordGroups
} from '@/api/keywords';
import { Keywords } from '@/models/keywords';

import { Callback } from '.';

export const useFetchKeywordGroups = (params?: Keywords.KeywordsParams) =>
  useQuery({
    queryKey: ['keywordGroups', params],
    queryFn: async () => {
      const result = await getKeywordGroups(params);

      return result.data.map((element: any) => ({
        ...element,
        type: 'Keyword group'
      }));
    },
    placeholderData: (previousData) => previousData
  });

export const useCreateKeywordGroup = (onSuccess: Callback, onError: Callback) =>
  useMutation({
    mutationFn: createKeywordGroup,
    onSuccess,
    onError
  });

export const useDeleteKeywordGroups = (
  onSuccess: Callback,
  onError: Callback
) =>
  useMutation({
    mutationFn: deleteKeywordGroups,
    onSuccess,
    onError
  });

export const useFetchKeywordGroupById = (id: number) =>
  useQuery({
    queryKey: ['keywordGroup', id],
    queryFn: async () => {
      const result = await getKeywordGroupById(id);
      return result.data;
    }
  });

export const useDeleteKeywords = (onSuccess: Callback, onError: Callback) =>
  useMutation({
    mutationFn: deleteKeywords,
    onSuccess,
    onError
  });

export const useCreateKeywords = (onSuccess: Callback, onError: Callback) =>
  useMutation({
    mutationFn: createKeywords,
    onSuccess,
    onError
  });
